import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SitemapEntry } from '@wdx/clmi/clmi-swagger-gen';
import { CrudStatus } from '@wdx/shared/utils';
import {
    EXTENDED_ROUTE_FEATURE_KEY,
    ExtendedRouteState,
} from './extended-route.reducer';

const selectExtendedRouteFeature = createFeatureSelector<ExtendedRouteState>(
    EXTENDED_ROUTE_FEATURE_KEY,
);

export const selectExtendedRouteState = createSelector(
    selectExtendedRouteFeature,
    (state) => state,
);

export const selectExtendedRouteStatus = createSelector(
    selectExtendedRouteFeature,
    (state): CrudStatus => state?.status ?? CrudStatus.Initial,
);

export const selectIsExtendedRoutePending = createSelector(
    selectExtendedRouteStatus,
    (status) => status === CrudStatus.Pending,
);

export const selectExtendedSitemapEntry = createSelector(
    selectExtendedRouteFeature,
    (state): SitemapEntry | undefined => state?.sitemapEntry,
);

export const selectExtendedParentSitemapEntries = createSelector(
    selectExtendedRouteFeature,
    (state): SitemapEntry[] | undefined => state?.parentSitemapEntries,
);

export const selectExtendedWholeSitemap = createSelector(
    selectExtendedRouteFeature,
    (state): SitemapEntry[] | undefined => state?.wholeSitemap,
);

export const selectExtendedIsAdminArea = createSelector(
    selectExtendedRouteFeature,
    (state): boolean | undefined => state?.isAdminArea,
);
